/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


//before dom content loaded
window.addEventListener("load", function () {


});

function addVariantWithUpsell(variantId, qty, upsellId) {
    // console.log("addVariantToCart", variantId, qty, upsellId);

    let formData = {
        'items': [
            {
                'id': variantId,
                'quantity': qty
            }
        ]
    };

    //get selectedUpsellVariants from localStorage
    let selectedUpsellVariants = JSON.parse(window.localStorage.getItem('selectedUpsellVariants'));

    if (selectedUpsellVariants && selectedUpsellVariants.length > 0) {
        selectedUpsellVariants.forEach((selectedUpsell) => {
            formData.items.push({
                'id': selectedUpsell.id,
                'quantity': selectedUpsell.qty
            });
        });
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
        .then(response => {
            if (!response.ok) {
                // Handle non-2xx HTTP responses
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            // console.log('Successfully added item to cart:', data);
            window.location.href = '/cart';
        })
        .catch(error => {
            console.error('Failed to add items to cart:', error);
            const errorElement = document.getElementById('event-error');
            if (errorElement) {
                errorElement.innerHTML = `Error: ${error.message}`;
                errorElement.style.display = 'block';
            }
        });

}

// Function to add a variant ID to the Shopify cart
function addVariantToCart(variantId) {

    var formElement = document.querySelector('form[action*="/cart/add"]');

    if (formElement) {
        // Create a new FormData object from the form
        var formData = new FormData(formElement);

        // Append the variant ID to the FormData object
        formData.append('id', variantId);

        // Send the form data to the Shopify cart
        fetch('/cart/add', {
            method: 'POST',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    } else {
        console.error('Form element not found');
    }


}

document.addEventListener('DOMContentLoaded', function () {

const productForm = document.querySelector('form[action*="/cart/add"]');
if (!productForm) return;

productForm.addEventListener('submit', function (e) {
e.preventDefault();

const variantInput = productForm.querySelector('[name="id"]');
if (!variantInput) return;

const mainVariantId = parseInt(variantInput.value);
const qtyInput = productForm.querySelector('[name="quantity"]');
const qty = qtyInput ? parseInt(qtyInput.value) : 1;

addVariantWithUpsell(mainVariantId, qty);
});

});

function addUpsellToCart(variantId, target) {

    //look for the closest qtyInput and get its value

    var qtyInput = target.closest('.accessoires-item').querySelector('.qtyInput');
    var qty = parseInt(qtyInput.value);

    if(qty === 0){
        return;
    }
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    
    console.log("addUpsellToCart", variantId, qty);

    let formData = {
        'items': [
            {
                'id': variantId,
                'quantity': qty
            }
        ]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
        .then(response => {
            if (!response.ok) {
                // Handle non-2xx HTTP responses
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            if (response.ok) {

                target.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                        variant: variantId,
                        quantity: 1
                    }
                }));
            }

            return response.json();
        })
        .then(data => {
            console.log('Successfully added item to cart:', data);

        })
        .catch(error => {
            console.log('Failed to add items to cart:', error);

        });

}


let isShippingAvailableForAllProducts = true; // Boolean to track shipping availability

document.addEventListener("DOMContentLoaded", async function () {


    //bundle upsell quantity selector validation
    if (window.location.pathname.includes('/products')) {
        // Find all quantity selectors
        const quantitySelectors = document.querySelectorAll('.accessoires-quantity-selector');

        quantitySelectors.forEach(selector => {
            const qtyDecrease = selector.querySelector('.qtyDecrease');
            const qtyIncrease = selector.querySelector('.qtyIncrease');
            const qtyInput = selector.querySelector('.qtyInput');

            // Add event listener for decrement button
            qtyDecrease.addEventListener('click', function () {
                if (parseInt(qtyInput.value) > 0) {
                    qtyInput.value = parseInt(qtyInput.value) - 1;
                }
            });

            // Add event listener for increment button
            qtyIncrease.addEventListener('click', function () {
                qtyInput.value = parseInt(qtyInput.value) + 1;
            });

            //add a change listener to the input field
            qtyInput.addEventListener('input', function () {
                if (parseInt(qtyInput.value) > 200) {
                    qtyInput.value = 200;
                }

                if (parseInt(qtyInput.value) < 0) {
                    qtyInput.value = 0;
                }

                //if not parseable to int, set to 0
                if (isNaN(parseInt(qtyInput.value))) {
                    qtyInput.value = 0;
                }


            });
        });
    }
    

    // Create the overlay
    const overlay = document.createElement('div');
    overlay.classList.add('product-form__zubehoer-overlay');
    overlay.id = 'product-form__zubehoer-overlay';

    // Create the popup
    const popup = document.createElement('div');
    popup.classList.add('product-form__zubehoer-popup');
    popup.id = 'product-form__zubehoer-popup';

    // Create the close button
    const closeButton = document.createElement('div');
    closeButton.classList.add('product-form__zubehoer-close-btn');
    closeButton.id = 'product-form__zubehoer-closePopup';
    closeButton.innerHTML = '&times;';

    // Create the popup container
    const popupContainer = document.createElement('div');
    popupContainer.classList.add('product-form__zubehoer-popup-container');

    // Add content to the popup container
    const content = document.createElement('p');
    content.textContent = 'Zubehör';
    content.classList.add("product-form__zubehoer-heading");
    popupContainer.appendChild(content);

    // Example dynamic content (replace with your actual dynamic content logic)
    const exampleContent = document.createElement('div');
    exampleContent.classList.add('product-form__zuebehoer-content')

    // Add a grid that shows the zubehoer here. It's Shopify products, it should show product.featured_image and product.title
    if (typeof zubehoer !== 'undefined' && zubehoer) {

        // Clear localStorage zubehoer selectedUpsellVariants
        window.localStorage.removeItem('selectedUpsellVariants');

        zubehoer.forEach((product) => {

            // Add a product card here
            const productCard = document.createElement('div');
            productCard.classList.add('product-form__zubehoer-card');

            // Create a container for the 3 columns
            const productColumns = document.createElement('div');
            productColumns.classList.add('product-form__zubehoer-columns');

            // Column 1: Checkbox for upsell selection
            const checkboxColumn = document.createElement('div');
            checkboxColumn.classList.add('product-form__zubehoer-column');
            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.className = 'upsell-checkbox';
            checkbox.value = product.variants[0].id;
            checkboxColumn.appendChild(checkbox);

            // Column 2: Product image
            const imageColumn = document.createElement('div');
            imageColumn.classList.add('product-form__zubehoer-column');
            const productImage = document.createElement('img');
            productImage.src = product.featured_image;
            productImage.alt = product.title;
            productImage.classList.add('product-form__zubehoer-image');
            imageColumn.appendChild(productImage);

            // Column 3: Product information text
            const infoColumn = document.createElement('div');
            infoColumn.classList.add('product-form__zubehoer-column');
            const productTitle = document.createElement('p');
            productTitle.textContent = product.title;
            productTitle.classList.add('product-form__zubehoer-title');
            const productPrice = document.createElement('div');
            productPrice.classList.add('product-form__zubehoer-price');


            var realPrice = product.price / 100 + ' € (19% MwSt.)';
            // var mwstPrice = parseInt(product.price / 1.19) / 100 + ' € (0% MwSt.)';
            var mwstPrice = parseInt(product.price) / 100 + ' € (0% MwSt.)';

            var realPriceElement = document.createElement('span');
            realPriceElement.classList.add("accessoires-item__text-price-ohnemwst");
            realPriceElement.textContent = mwstPrice;

            var mwstPriceElement = document.createElement('span');
            mwstPriceElement.classList.add("accessoires-item__text-price-mwst");
            mwstPriceElement.textContent = realPrice;

            productPrice.appendChild(mwstPriceElement);
            productPrice.appendChild(realPriceElement);


            const qtyColumn = document.createElement('div');
            qtyColumn.classList.add('product-form__zubehoer-column');

            const qtyDecrease = document.createElement('div');
            qtyDecrease.textContent = "-";
            qtyDecrease.classList.add('product-form__zubehoer-qty-decrease');
            qtyDecrease.addEventListener('click', function () {
                if (parseInt(qtyInput.value) > 0) {
                    qtyInput.value = parseInt(qtyInput.value) - 1;

                    if (parseInt(qtyInput.value) === 0) {
                        checkbox.checked = false;
                        qtyDecrease.closest('product-form__zubehoer-card').classList.remove('selectedUpsellVariant');
                    }
                }
            });
            qtyColumn.appendChild(qtyDecrease);
            
            const qtyInput = document.createElement('input');
            qtyInput.type = 'number';
            qtyInput.value = 1;
            qtyInput.min = 0;
            qtyInput.max = 200;
            qtyInput.classList.add('product-form__zubehoer-qty');

            //make sure user can only input numbers and number max 200
            qtyInput.addEventListener('input', function () {
                if (parseInt(qtyInput.value) > 200) {
                    qtyInput.value = 200;
                }

                if (parseInt(qtyInput.value) > 0) {
                    checkbox.checked = true;
                    qtyInput.closest('product-form__zubehoer-card').classList.add('selectedUpsellVariant');
                }
                else {
                    checkbox.checked = false;
                    qtyInput.closest('product-form__zubehoer-card').classList.remove('selectedUpsellVariant');
                }
            });
          

            qtyColumn.appendChild(qtyInput);
            const qtyIncrease = document.createElement('div');
            qtyIncrease.textContent = "+";
            qtyIncrease.classList.add('product-form__zubehoer-qty-increase');
            qtyIncrease.addEventListener('click', function () {
                qtyInput.value = parseInt(qtyInput.value) + 1;
                checkbox.checked = true;

                qtyIncrease.closest('product-form__zubehoer-card').classList.add('selectedUpsellVariant');

                if (parseInt(qtyInput.value) > 200) {
                    qtyInput.value = 200;
                }
            });
            qtyColumn.appendChild(qtyIncrease);
           

            const productLink = document.createElement('a');
            productLink.href = "/products/" + product.handle;
            productLink.textContent = "Zum Produkt";
            productLink.classList.add('product-form__zubehoer-link');
            productLink.target = "_blank";
            const productInfoDiv = document.createElement('div');
            productInfoDiv.classList.add('product-form__zubehoer-info');

            productInfoDiv.appendChild(productTitle);
            productInfoDiv.appendChild(productPrice);
            productInfoDiv.appendChild(productLink);
            infoColumn.appendChild(productInfoDiv);

            // Append columns to the product card
            productColumns.appendChild(checkboxColumn);
            productColumns.appendChild(imageColumn);
            productColumns.appendChild(infoColumn);
            productColumns.appendChild(qtyColumn);
            productCard.appendChild(productColumns);

            // Make the whole product card clickable
            productCard.addEventListener('click', function (event) {

                //if the event target is qtyColumn or its children, do nothing
                if (event.target === qtyColumn || event.target === qtyIncrease || event.target === qtyDecrease || event.target === qtyInput) {
                    return;
                }

                if (event.target !== checkbox) {
                    checkbox.checked = !checkbox.checked;
                    checkbox.closest('product-form__zubehoer-card').classList.remove('selectedUpsellVariant');
                }

                //
            });

            // Append the product card to the example content
            exampleContent.appendChild(productCard);
        });

        popupContainer.appendChild(exampleContent);

        // Create Save button
        const saveButton = document.createElement('button');
        saveButton.textContent = 'Auswahl speichern';
        saveButton.id = 'save-upsell-button';
        popupContainer.appendChild(saveButton);

        // Append the close button and container to the popup
        popup.appendChild(closeButton);
        popup.appendChild(popupContainer);

        // Append the popup to the overlay
        overlay.appendChild(popup);

        // Append the overlay to the body
        document.body.appendChild(overlay);

        // Show popup function
        function showPopup() {

            // Check for each product if its id is in localStorage selectedUpsellVariants
            var selectedVariantIds = JSON.parse(window.localStorage.getItem('selectedUpsellVariants')) || [];
            document.querySelectorAll('.upsell-checkbox').forEach(function (checkbox) {
                if (selectedVariantIds.find((selectedVariant) => selectedVariant.id === parseInt(checkbox.value))) {
                    checkbox.checked = true;
                    
                } else {
                    checkbox.checked = false;
                    
                }
            });

            overlay.style.display = 'flex';
        }

        // Event listener to close the popup
        closeButton.addEventListener('click', function () {
            overlay.style.display = 'none';
        });

        // Event listener to close the popup when clicking outside
        overlay.addEventListener('click', function (event) {
            if (event.target === overlay) {
                overlay.style.display = 'none';
            }
        });

        // Example: Event to open the popup (replace with your actual trigger)
        document.getElementById('product-form__zubehoer-addButton').addEventListener('click', showPopup);

        // Event listener for Save button
        saveButton.addEventListener('click', function () {
            let selectedVariantIds = [];
            document.querySelectorAll('.upsell-checkbox:checked').forEach(function (checkbox) {

                //look for closest product-form__zubehoerqty
                var qty = checkbox.parentElement.parentElement.getElementsByClassName('product-form__zubehoer-qty')[0].value;

                var selectedVariant = {
                    id: parseInt(checkbox.value),
                    qty: qty
                };
                selectedVariantIds.push(selectedVariant);

            });

            // Store selected variant IDs in localStorage
            window.localStorage.setItem('selectedUpsellVariants', JSON.stringify(selectedVariantIds));

            // Close the popup
            overlay.style.display = 'none';


            var addedZubehoer = [];
            // Find the selected productIds in the zubehoer array
            selectedVariantIds.forEach((selectedVariant) => {
                // console.log(selectedVariant, "selectedVariant");
                // console.log(zubehoer, "zubehoer");
                var selectedProduct = zubehoer.find((product) => product.variants[0].id === selectedVariant.id);
                // console.log(selectedProduct, "selectedProduct");
                selectedProduct.variants[0].quantity = selectedVariant.qty;
                addedZubehoer.push({product: selectedProduct, qty: selectedVariant.qty});
            }
            );

            // Add every addedZubehoer below product-form__zubehoer-addButton as an element with a remove button (X)
            var zubehoerContainer = document.getElementsByClassName("product-form__zubehoer-main")[0];
            zubehoerContainer.innerHTML = '';

            addedZubehoer.forEach((product) => {
                var productElement = document.createElement('div');
                productElement.classList.add('product-form__zubehoer-added');

                var removeButton = document.createElement('button');
                removeButton.textContent = 'x';
                removeButton.classList.add('product-form__zubehoer-remove');
                removeButton.addEventListener('click', function () {
                    // Remove product from addedZubehoer
                    addedZubehoer = addedZubehoer.filter((addedProduct) => addedProduct.variants[0].id !== product.product.variants[0].id);
                    // Remove productElement
                    productElement.remove();

                    // Remove product from localStorage selectedUpsellVariants where id = product.variants[0].id
                    selectedVariantIds = selectedVariantIds.filter((selectedVariant) => selectedVariant.id !== product.product.variants[0].id);
                    window.localStorage.setItem('selectedUpsellVariants', JSON.stringify(selectedVariantIds));
                });

                var productTitle = document.createElement('span');
                productTitle.textContent = product.qty + " x " + (product.product.title.length > 50 ? product.product.title.substring(0, 50) + '...' : product.product.title);

                productElement.appendChild(removeButton);
                productElement.appendChild(productTitle);
                zubehoerContainer.appendChild(productElement);
            });
        });
    }

    if (window.location.href.includes("product")) {

    }

    await removeDiscountFromCart();


    window.ZapietEvent.listen('widget_loaded', function (event) {
        console.log("widget_loaded");
        getStoreDetails(true);

    });

    window.ZapietEvent.listen("selected_method", function (checkout_method) {
        switch (checkout_method) {
            case "pickup":
                console.log("pickup");
                let checkoutButton = document.querySelector('button[name="checkout"]');
                if (checkoutButton) {
                    checkoutButton.disabled = false;
                }

                break;
            case "delivery":
                console.log("delivery");
                // Do something when delivery is selected 
                break;
            case "shipping":
                console.log("shipping");

                let checkoutButton2 = document.querySelector('button[name="checkout"]');
                if (checkoutButton2) {
                    checkoutButton2.disabled = true;
                }

                if (!isShippingAvailableForAllProducts) {
                    //timeout to wait for shipping note to be rendered
                    setTimeout(function () {
                        let shippingNote = document.querySelector('.checkoutMethodContainer.shipping .shipping_note');
                        if (shippingNote) {
                            console.log("shippingNote");
                            shippingNote.textContent = "Leider ist der Versand für die aktuelle Zusammenstellung Ihres Warenkorbs nicht möglich. Bitte überprüfen Sie die Produkte und deren Mengen auf Verfügbarkeit.";
                            shippingNote.style.color = "#e54949";
                        } else {
                            console.log("no shipping note");
                        }
                    }, 1000);
                    break;
                } else {
                    let checkoutButton = document.querySelector('button[name="checkout"]');
                    if (checkoutButton) {
                        checkoutButton.disabled = false;
                    }
                }
                break;
        }
        
    });

    window.ZapietEvent.listen('pickup.timepicker.rendered', function () {
        var el = document.getElementById('cart-recap__scroller');
        var items = document.getElementById('cart__product-table').childElementCount;

        // if (window.screen.width < 1000) {
        //     var textWithIcons = document.getElementById("text-with-icons__section");
        //     if (textWithIcons != null) {
        //         textWithIcons.style.marginTop = "350px";

        //     }
        //     var addedHeight = items * 130;
        //     document.getElementById("cart__section").style.height = el.offsetHeight + addedHeight + 200 + "px";
        // }
        // else {
        //     var addedHeight = items * 100;
        //     document.getElementById("cart__section").style.height = el.offsetHeight + addedHeight + "px";
        // }

    });
});


async function removeDiscountFromCart() {

    //if url is /cart
    if (window.location.href.includes("cart")) {

        //get cart from window.cart
        var changed = false;

        var newItems = [];

        cart.items.forEach(async function (item) {
            var newItem = item;
            var properties = item.properties;
            newItem.properties = "";
            newItems.push(newItem);

            if (properties.hasOwnProperty("MwSt.")) {
                changed = true;
            };
        });

        if (changed) {
            cart = await clearCart(cart.token);

            body = { "items": newItems };
            // console.log(cart, "cart");
            // console.log(body, "new items");

            await fetch("".concat(window.Shopify.routes.root, "cart/add.js"), {
                body: JSON.stringify(body),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Accept": "application/json",
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (data) {
                // console.log(data);
            }).catch(function (error) {
                console.error(error);
            });
        }

        if (changed) {
            location.reload();
        }
        // cart.items.forEach(async function (item) {

        //     //if item.properties is json, check if it contains key mwst
        //     var properties = item.properties;
        //     console.log(properties, "item properties");
        //     if (properties.hasOwnProperty("MwSt.")) {
        //         console.log("item has discount");
        //         await removeDiscountFromCartItem(item);
        //     }
        //     //if last item in cart and changed = true, refresh
        //     console.log(changed, "changed")

        //     if (item === cart.items[cart.items.length - 1] && changed) {
        //         location.reload();
        //     }


        // });
        // await fetch("".concat(window.routes.cartUrl, ".js"), {
        //     credentials: 'same-origin',
        //     method: 'GET',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         "Accept": "application/json",
        //         'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        //     }
        // }).then(function (response) {
        //     return response.json();
        // }).then(function (cart) {
        //     //foreach item in cart remove discount




        // });

    }

}
async function clearCart(cartToken) {
    return fetch("".concat(window.routes.cartUrl, "/clear.js"), {
        credentials: 'same-origin',
        body: JSON.stringify({
            "token": cartToken
        }),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "Accept": "application/json",
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
    }).then(function (response) {
        return response.json();
    }).then(function (cart) {
        // console.log(cart);
        return cart;
    });
}
async function removeDiscountFromCartItem(item) {

    var newCartItem = item;
    newCartItem.properties = "";
    var itemKey = item.key;
    var itemVariant = item.id;

    var body = {
        "updates": {
            [itemKey]: 0
        }
    };
    //remove discount
    await fetch("".concat(window.Shopify.routes.root, "cart/update.js"), {
        body: JSON.stringify(body),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "Accept": "application/json",
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
    }).then(function (response) {
        return response.json(); // Parse the response as JSON
    }).then(async function (data) {

        //add item without discount
        body = { "items": [newCartItem] };
        await fetch("".concat(window.Shopify.routes.root, "cart/add.js"), {
            body: JSON.stringify(body),
            credentials: 'same-origin',

            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Accept": "application/json",
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            // console.log(data);
        }).catch(function (error) {
            console.error(error);
        });
        console.log(data); // Log the parsed JSON response
    }).catch(function (error) {
        console.error(error); // Log any errors
    });
}

function fetchStoreDetails(request) {
    return fetch("https://api-us.zapiet.com/v1.0/pickup/locations?api_key=e8ca34f81a1cfb3b58c71904450da9b6&shop=isolarpro.myshopify.com", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)
    }).then((response) => response.json())
        .then((responseData) => {

            return responseData;
        });
}

let isStoreDetailsLoaded = false;

function adjustCartHeight() {
        
    let cartSection = document.getElementById("cart__section");
    cartSection.style.height = 'auto';
}

async function getStoreDetails() {
    console.log("getStoreDetails");

    isShippingAvailableForAllProducts = true;

    function addLocationInfo(container, className, textContent, parentElement) {
        let heading = document.createElement("p");
        heading.appendChild(document.createTextNode(textContent));
        heading.classList.add(className);
        container.appendChild(heading);
        parentElement.appendChild(container);
    }

    function addLocationName(container, locationName) {
        let locationInfo = document.createElement("p");
        locationInfo.appendChild(document.createTextNode("- " + locationName));
        locationInfo.classList.add("cartLocationName");
        container.appendChild(locationInfo);
    }

  
    

    function clearPreviousContainers(parentElement, className) {
        let existingContainers = parentElement.getElementsByClassName(className);
        while (existingContainers.length > 0) {
            existingContainers[0].parentNode.removeChild(existingContainers[0]);
        }
    }

    var cartItems = document.getElementById("cart__product-table").children;

    for (let i = 0; i < cartItems.length; i++) {
        var prodCard = cartItems[i];
        var productId = prodCard.getAttribute("data-product-id");
        var productName = prodCard.getAttribute("data-product-name"); // Ensure this attribute exists
        var variantId = prodCard.getAttribute("data-variant-id");
        var qty = prodCard.getAttribute("data-quantity");

        var request = {
            "shoppingCart": [
                {
                    "variant_id": variantId,
                    "product_id": productId,
                    "quantity": qty
                }
            ]
        };

        var responseData = await fetchStoreDetails(request);
        var parElement = prodCard.getElementsByClassName("line-item__product-info")[0];

        if (parElement) {
            clearPreviousContainers(parElement, "shippingContainer");
            clearPreviousContainers(parElement, "pickupContainer");
            clearPreviousContainers(parElement, "no-location-info");

            var shippingHeading = document.createElement("div");
            shippingHeading.classList.add("shippingContainer");
            var pickupHeading = document.createElement("div");
            pickupHeading.classList.add("pickupContainer");

            if (responseData.locations.length === 0) {
                let noLocationInfo = document.createElement("p");
                noLocationInfo.textContent = `Dieses Produkt ist in der gewählten Menge nicht für Abholung oder Versand verfügbar. Bitte passen Sie die Menge an oder kontaktieren Sie uns für weitere Optionen.`;
                noLocationInfo.style.color = "#e54949";
                noLocationInfo.classList.add("no-location-info");
                parElement.appendChild(noLocationInfo);

                isShippingAvailableForAllProducts = false;
            } else {
                addLocationInfo(shippingHeading, "shippingHeading", "Wird versendet aus: ", parElement);
                addLocationInfo(pickupHeading, "pickupHeading", "Zur Abholung verfügbar in: ", parElement);

                let shippingAvailable = false;

                responseData.locations.forEach((loc) => {
                    addLocationName(pickupHeading, loc.company_name);
                    if (loc.company_name.toLowerCase().includes("moers")) {
                        addLocationName(shippingHeading, loc.company_name);
                        shippingAvailable = true;
                    }
                });

                if (!shippingAvailable) {
                    let noShippingInfo = document.createElement("p");
                    noShippingInfo.textContent = `Kein Versand für dieses Produkt verfügbar.`;
                    noShippingInfo.style.color = "#e54949";
                    shippingHeading.appendChild(noShippingInfo);

                    isShippingAvailableForAllProducts = false;
                }

                parElement.appendChild(shippingHeading);
                parElement.appendChild(pickupHeading);
            }

            
        }
    }
    adjustCartHeight();


    if (!isShippingAvailableForAllProducts) {
        let checkoutButton = document.querySelector('button[name="checkout"]');
        if (checkoutButton) {
            checkoutButton.disabled = true;
        }

        let shippingNote = document.querySelector('.checkoutMethodContainer.shipping .shipping_note');

        if (shippingNote) {
            console.log("shippingNote");
            shippingNote.textContent = "Leider ist der Versand für die aktuelle Zusammenstellung Ihres Warenkorbs nicht möglich. Bitte überprüfen Sie die Produkte und deren Mengen auf Verfügbarkeit.";
            shippingNote.style.color = "#e54949";
        }
    }
    else {
        let checkoutButton = document.querySelector('button[name="checkout"]');
        if (checkoutButton) {
            checkoutButton.disabled = false;
        }

        let shippingNote = document.querySelector('.checkoutMethodContainer.shipping .shipping_note');

        if (shippingNote) {
            console.log("shippingNote");
            shippingNote.textContent = "Bitte klicken Sie zum Fortfahren auf den Kasse-Button.";
            shippingNote.style.color = "#5f5f60";
        }

    }


    console.log("Is shipping available for all products:", isShippingAvailableForAllProducts);
}



async function fetchProductPageDetails(request) {
    const response = await fetch("https://api-us.zapiet.com/v1.0/pickup/locations?api_key=e8ca34f81a1cfb3b58c71904450da9b6&shop=isolarpro.myshopify.com", {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request)
    });
    return await response.json();
}

async function renderProductAvailability() {
    const parElement = document.getElementById("product-page-locations");
    const wrapper = document.getElementById("product-availability-dynamic");

    parElement.innerHTML = "";

    const productId = document.querySelector('[name="product-id"]').value;
    const variantId = document.querySelector('form[action*="/cart/add"] [name="id"]').value;

    const request = {
        "shoppingCart": [{
            "variant_id": variantId,
            "product_id": productId,
            "quantity": 1
        }]
    };
    
    try {
        const responseData = await fetchProductPageDetails(request);

        //console.log("responseData:", JSON.stringify(responseData, null, 2));

        if (responseData.locations && responseData.locations.length > 0) {
            
            let shippingContainer = document.createElement("div");
            shippingContainer.classList.add("shippingContainer");
            shippingContainer.innerHTML = '<p class="shippingHeading" style="font-weight:500; text-decoration:underline;">Wird versendet aus:</p>';

            let pickupContainer = document.createElement("div");
            pickupContainer.classList.add("pickupContainer");
            pickupContainer.innerHTML = '<p class="pickupHeading" style="font-weight:500;  margin-top:15px; text-decoration:underline;">Zur Abholung verfügbar in:</p>';

            let shippingAvailable = false;

            responseData.locations.forEach((loc) => {
                let pLoc = document.createElement("p");
                pLoc.classList.add("cartLocationName");
                pLoc.style.color = "green";
                pLoc.textContent = "- " + loc.company_name;
                pickupContainer.appendChild(pLoc);

                if (loc.company_name.toLowerCase().includes("moers")) {
                    let sLoc = document.createElement("p");
                    sLoc.classList.add("cartLocationName");
                    sLoc.style.color = "green";
                    sLoc.textContent = "- " + loc.company_name;
                    shippingContainer.appendChild(sLoc);
                    shippingAvailable = true;
                }
            });

            parElement.appendChild(shippingContainer);
            parElement.appendChild(pickupContainer);
            wrapper.style.display = "block";

            const target = document.querySelector(".product-meta__title heading h1");
            if (target) {
                target.parentNode.insertBefore(wrapper, target.nextSibling);
            }
        }
    } catch (e) {
        console.error("Zapiet Product Page Error:", e);
    }
}

document.addEventListener("DOMContentLoaded", renderProductAvailability);

document.addEventListener('variant:changed', function() {
    renderProductAvailability();
});